var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _circle27, _circle28, _circle29, _circle30, _circle31, _circle32, _circle33, _circle34, _circle35, _circle36, _circle37, _circle38, _circle39, _circle40, _circle41, _circle42, _circle43, _circle44, _circle45, _circle46, _circle47, _circle48;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScatteredNight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 43,
    viewBox: "0 0 58 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1381,
    cy: 2.62835,
    r: 2.62835,
    fill: "black"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3911,
    cy: 2.62835,
    r: 2.62835,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6489,
    cy: 2.62835,
    r: 2.62835,
    fill: "black"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.88977,
    cy: 7.88977,
    r: 2.63,
    fill: "black"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.63,
    cy: 13.15,
    r: 2.63,
    fill: "black"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.63,
    cy: 18.4098,
    r: 2.63,
    fill: "black"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.63,
    cy: 23.67,
    r: 2.63,
    fill: "black"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 2.63,
    cy: 28.9298,
    r: 2.63,
    fill: "black"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1381,
    cy: 7.88812,
    r: 2.62835,
    fill: "black"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.88812,
    cy: 13.1484,
    r: 2.62835,
    fill: "black"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.88812,
    cy: 18.4081,
    r: 2.62835,
    fill: "black"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.88812,
    cy: 23.6684,
    r: 2.62835,
    fill: "black"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.88812,
    cy: 28.9282,
    r: 2.62835,
    fill: "black"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3881,
    cy: 7.88812,
    r: 2.62835,
    fill: "black"
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1381,
    cy: 13.1484,
    r: 2.62835,
    fill: "black"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1381,
    cy: 18.4081,
    r: 2.62835,
    fill: "black"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1381,
    cy: 23.6684,
    r: 2.62835,
    fill: "black"
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1381,
    cy: 28.9282,
    r: 2.62835,
    fill: "black"
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3979,
    cy: 28.9282,
    r: 2.62835,
    fill: "black"
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 7.88977,
    cy: 34.1901,
    r: 2.63,
    fill: "black"
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1381,
    cy: 34.1884,
    r: 2.62835,
    fill: "black"
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3979,
    cy: 34.1884,
    r: 2.62835,
    fill: "black"
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6586,
    cy: 34.1884,
    r: 2.62835,
    fill: "black"
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9184,
    cy: 34.1884,
    r: 2.62835,
    fill: "black"
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 13.1381,
    cy: 39.4482,
    r: 2.62835,
    fill: "black"
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 18.3979,
    cy: 39.4482,
    r: 2.62835,
    fill: "black"
  })), _circle27 || (_circle27 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6586,
    cy: 39.4482,
    r: 2.62835,
    fill: "black"
  })), _circle28 || (_circle28 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9184,
    cy: 39.4482,
    r: 2.62835,
    fill: "black"
  })), _circle29 || (_circle29 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1782,
    cy: 34.1884,
    r: 2.62835,
    fill: "black"
  })), _circle30 || (_circle30 = /*#__PURE__*/React.createElement("circle", {
    cx: 23.6603,
    cy: 18.4098,
    r: 2.63,
    fill: "black"
  })), _circle31 || (_circle31 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9184,
    cy: 18.4081,
    r: 2.62835,
    fill: "black"
  })), _circle32 || (_circle32 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9184,
    cy: 13.1484,
    r: 2.62835,
    fill: "black"
  })), _circle33 || (_circle33 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1782,
    cy: 18.4081,
    r: 2.62835,
    fill: "black"
  })), _circle34 || (_circle34 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.4379,
    cy: 18.4081,
    r: 2.62835,
    fill: "black"
  })), _circle35 || (_circle35 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6987,
    cy: 18.4081,
    r: 2.62835,
    fill: "black"
  })), _circle36 || (_circle36 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9584,
    cy: 18.4081,
    r: 2.62835,
    fill: "black"
  })), _circle37 || (_circle37 = /*#__PURE__*/React.createElement("circle", {
    cx: 28.9184,
    cy: 23.6684,
    r: 2.62835,
    fill: "black"
  })), _circle38 || (_circle38 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.1782,
    cy: 23.6684,
    r: 2.62835,
    fill: "black"
  })), _circle39 || (_circle39 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.4379,
    cy: 23.6684,
    r: 2.62835,
    fill: "black"
  })), _circle40 || (_circle40 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6987,
    cy: 23.6684,
    r: 2.62835,
    fill: "black"
  })), _circle41 || (_circle41 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9584,
    cy: 23.6684,
    r: 2.62835,
    fill: "black"
  })), _circle42 || (_circle42 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2182,
    cy: 18.4081,
    r: 2.62835,
    fill: "black"
  })), _circle43 || (_circle43 = /*#__PURE__*/React.createElement("circle", {
    cx: 39.4379,
    cy: 13.1484,
    r: 2.62835,
    fill: "black"
  })), _circle44 || (_circle44 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6987,
    cy: 13.1484,
    r: 2.62835,
    fill: "black"
  })), _circle45 || (_circle45 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9584,
    cy: 13.1484,
    r: 2.62835,
    fill: "black"
  })), _circle46 || (_circle46 = /*#__PURE__*/React.createElement("circle", {
    cx: 44.6987,
    cy: 7.88812,
    r: 2.62835,
    fill: "black"
  })), _circle47 || (_circle47 = /*#__PURE__*/React.createElement("circle", {
    cx: 49.9584,
    cy: 7.88812,
    r: 2.62835,
    fill: "black"
  })), _circle48 || (_circle48 = /*#__PURE__*/React.createElement("circle", {
    cx: 55.2182,
    cy: 13.1484,
    r: 2.62835,
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScatteredNight);
export default __webpack_public_path__ + "static/media/scattered-night.dace9c0d2711a7f6952ec92c5e50d5de.svg";
export { ForwardRef as ReactComponent };